import { PlusOutlined, SyncOutlined } from '@ant-design/icons'
import { GraviButton, Horizontal } from '@gravitate-js/excalibrr'
import { CreateMappingDrawer } from '@pages/Dashboard/panels/ReferenceDataPanel/components/CreateMappingDrawer'
import { useCreateMappingDrawer } from '@pages/Dashboard/panels/ReferenceDataPanel/hooks/useCreateMappingDrawer'
import { Tooltip } from 'antd'
import type React from 'react'
import { UploadDownloadButtons } from '../../../../../components/UploadDownload/UploadDownloadButtons'

interface FilterControlsProps {
  onSync: () => Promise<void>
  onRefresh: () => void
}

/**
 * Filter controls component for ReferenceDataPanel
 * Includes mapping status filter, sync button, upload/download buttons, and filter alerts
 */
export const MappingGridControls: React.FC<FilterControlsProps> = ({
  onSync,
  onRefresh,
}) => {
  const { isOpen, openDrawer, closeDrawer, prefillValues } =
    useCreateMappingDrawer()

  return (
    <Horizontal gap={8} alignItems='center'>
      <UploadDownloadButtons refreshCallback={onRefresh} />
      <Tooltip title='Sync data'>
        <GraviButton icon={<SyncOutlined />} onClick={onSync} />
      </Tooltip>
      <GraviButton
        buttonText={'Create Mapping'}
        theme2={true}
        onClick={openDrawer}
        icon={<PlusOutlined />}
      />
      <CreateMappingDrawer
        open={isOpen}
        onClose={closeDrawer}
        onCreate={(e) => console.log(e)}
        prefillValues={prefillValues}
      />
    </Horizontal>
  )
}
